import session from '@/shared/session'

// initial state
const state = {
	current : {},
}

// getters
const getters = {}

// actions
const actions = {
	conditioningtypeOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/conditioningtypes/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	conditioningtypeDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/conditioningtypes/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	conditioningtypeCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/conditioningtypes/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	conditioningtypeUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/conditioningtypes/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	conditioningtypeRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/conditioningtypes/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterconditioningtype ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/conditioningtypes/get_filtered_conditioningtypes/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    conditioningtypeStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/conditioningtypes/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
